import { render, staticRenderFns } from "./avatar_labeled.vue?vue&type=template&id=0facd5cf"
import script from "./avatar_labeled.vue?vue&type=script&lang=js"
export * from "./avatar_labeled.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports